<template>
  <b-card>
    <div class="flex mb-2 gap-3 items-center">
      <b-img
        class="cursor-pointer mt-[-0.5rem]"
        src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
        alt=""
        @click="$router.back()"
      />
      <h4>
        <strong class="text-black text-2xl">{{ pageTitle }}</strong>
      </h4>
    </div>
    <div class="lg:px-2">
      <steps
        :steps-data="stepsData"
        :current-step="currentStep"
      />
    </div>
    <b-overlay
      :show="disable"
      rounded="sm"
    >
      <div class="lg:pl-4">
        <b-form @submit.prevent="onSubmit">
          <div class="my-2 text-lg font-semibold text-[#333333] ">
            {{ titleStep() }}
          </div>
          <step-one
            v-show="currentStep === 1"
            :form-data="formData"
            :disable-next.sync="disableNext.first"
            @update:brand="value => (formData.brand = value)"
            @update:name="value => (formData.name = value)"
            @update:gender="value => (formData.gender = value)"
            @update:language_style="value => (formData.language_style = value)"
            @update:greeting="value => (formData.greeting = value)"
            @update:job_description="value => (formData.job_description = value)"
          />
          <step-two
            v-show="currentStep === 2"
            :disable-next.sync="disableNext.second"
            :form-data="formData"
            :is-edit-mode="isEditMode"
            :has-invalid-price.sync="hasInvalidPrice"
            :invalid-price-products.sync="invalidPriceProducts"
            @update:address-id="value => (formData.address_id = value)"
          />
          <step-three
            v-show="currentStep === 3"
            :form-data="formData"
            :has-invalid-price="hasInvalidPrice"
            :invalid-price-products="invalidPriceProducts"
            :bank-accounts="bankAccounts"
          />
          <div class="text-end">
            <b-button
              :disabled="currentStep <= 1"
              class="mr-1"
              variant="outline-secondary"
              size="sm"
              @click="prevStep"
            >
              Back
            </b-button>
            <b-button
              v-show="currentStep < stepsData.length"
              size="sm"
              variant="primary"
              :disabled="currentStep >= stepsData.length || handleDisableNext()"
              @click="nextStep"
            >Next
            </b-button>
            <b-button
              v-show="currentStep >= stepsData.length"
              size="sm"
              :disabled="isAnyFormDataEmpty()"
              variant="primary"
              @click="onSubmit"
            >
              {{ isEditMode ? 'Update' : 'Simpan' }}
            </b-button>
          </div>
        </b-form>
      </div>
    </b-overlay>
  </b-card>
</template>
<script>
import steps from '@/views/components/steps/steps.vue'
import stepOne from './StepOne.vue'
import stepTwo from './StepTwo.vue'
import stepThree from './StepThree.vue'
import { jobdesc } from './config'

import { apiCreateAgent, apiGetAgentDetail, apiUpdateAgent } from './service/api.agent.service'

export default {
  name: 'AddAiCustomerService',
  components: {
    steps,
    stepOne,
    stepTwo,
    stepThree,
  },
  data() {
    return {
      isEditMode: false, // Add this line to track edit mode
      currentStep: 1,
      whatsAppList: this.$store.state.komchat.whatsAppList,
      productList: this.$store.state.komchat.productList,
      stepsData: [
        {
          number: 1,
          name: 'Customer Service Personality',
          done: false,
          step: 'one',
        },
        {
          number: 2,
          name: 'Produk',
          done: false,
          step: 'two',
        },
        {
          number: 3,
          name: 'Pengaturan Tambahan',
          done: false,
          step: 'three',
        },
      ],
      formData: {
        phone_number: '',
        name: '',
        brand: '',
        gender: '',
        language_style: '',
        greeting: '',
        job_description: jobdesc,
        is_off_when_manually: false,
        payment_method: [],
        address_id: null,
        shipments: [],
        product_ids: [],
        products: [],
        bank_account_ids: [],
        times: [],
        product_discount: 0,
        payment_discount: 0,
        shipping_discount: 0,
        coverage_discount: '',
        reminder: [],
        email_close_order: false,
      },
      bankAccounts: [],
      disableNext: {
        first: false,
        second: false,
        third: false,
      },
      disable: false,
      hasInvalidPrice: false,
      invalidPriceProducts: [],
    }
  },
  computed: {
    pageTitle() {
      return this.isEditMode ? 'Edit Customer Service Personality' : 'Customer Service Personality'
    },
  },
  async mounted() {
    if (this.$route.params.id) {
      this.isEditMode = true
      try {
        await this.getAgentById()
        await this.$store.dispatch('komchat/getProductList', {
          keyword: '',
          page: 0,
          limit: 20,
          append: false,
        })
        await this.$store.dispatch('komchat/getWarehouseList')
        await this.$store.dispatch('komchat/getWhatsAppList')
      } catch (error) {
        console.error('Error loading data:', error)
        this.$toast_error({ message: 'Gagal memuat data' })
      }
    }
  },
  methods: {
    nextStep() {
      if (this.currentStep < this.stepsData.length) {
        this.currentStep += 1
        this.updateStepStatus()
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep -= 1
        this.updateStepStatus()
      }
    },
    updateStepStatus() {
      this.stepsData = this.stepsData.map(step => ({
        ...step,
        done: step.number < this.currentStep,
      }))
    },
    titleStep() {
      return this.stepsData[this.currentStep - 1].name
    },
    handleDisableNext() {
      const map = {
        1: this.disableNext.first,
        2: this.disableNext.second,
        3: this.disableNext.third,
      }
      return map[this.currentStep] ?? true
    },
    async onSubmit() {
      const idAgent = this.$route.params.id
      try {
        this.disable = true
        const cleanFormData = { ...this.formData }
        delete cleanFormData.products

        if (!this.isEditMode) {
          if (!cleanFormData.product_discount || cleanFormData.product_discount === 0) {
            delete cleanFormData.product_discount
          }
          if (!cleanFormData.payment_discount || cleanFormData.payment_discount === 0) {
            delete cleanFormData.payment_discount
          }
          if (!cleanFormData.shipping_discount || cleanFormData.shipping_discount === 0) {
            delete cleanFormData.shipping_discount
          }
          if (!cleanFormData.coverage_discount
              || (Array.isArray(cleanFormData.coverage_discount) && cleanFormData.coverage_discount.length === 0)
              || (typeof cleanFormData.coverage_discount === 'string' && cleanFormData.coverage_discount.trim() === '')) {
            delete cleanFormData.coverage_discount
          }
        }
        if (this.isEditMode) {
          await apiUpdateAgent(idAgent, cleanFormData)
          this.$toast_success({ message: 'Agen berhasil diperbarui' })
        } else {
          await apiCreateAgent(cleanFormData)
          this.$toast_success({ message: 'Agen berhasil dibuat' })
        }
        this.$router.push({ name: 'ai-customer-service' })
      } catch (error) {
        this.$toast_error({
          message: this.isEditMode
            ? 'Terjadi kesalahan saat memperbarui agen'
            : 'Terjadi kesalahan saat membuat agen',
        })
      } finally {
        this.disable = false
      }
    },
    async getAgentById() {
      const idAgent = this.$route.params.id
      try {
        this.disable = true
        const { data } = await apiGetAgentDetail(idAgent)

        const cleanedData = {
          phone_number: data.data.phone_number || '',
          name: data.data.name || '',
          brand: data.data.brand || '',
          gender: data.data.gender || '',
          language_style: data.data.language_style || '',
          greeting: data.data.greeting || '',
          job_description: data.data.job_description || '',
          is_off_when_manually: data.data.is_off_when_manually || false,
          payment_method: data.data.payment_method || '',
          address_id: data.data.address_id || null,
          shipments: data.data.shipments || [],
          product_ids: data.data.products ? data.data.products.map(product => product.product_id) : [],
          products: data.data.products ? data.data.products.map(p => ({
            id: p.product_id,
            product_name: p.name,
            product_image: p.url,
            product_price: p.price,
            product_sku: p.sku,
            product_stock: '-',
          })) : [],
          bank_account_ids: data.data.bank_account_ids || [],
          times: data.data.times || [],
          product_discount: data.data.product_discount || 0,
          payment_discount: data.data.payment_discount || 0,
          shipping_discount: data.data.shipping_discount || 0,
          coverage_discount: data.data.coverage_discount || '',
          reminder: data.data.reminder || [],
          email_close_order: data.data.email_close_order || false,
        }
        this.bankAccounts = data.data.bank_accounts || []
        Object.assign(this.formData, cleanedData)
      } catch {
        this.$toast_error({ message: 'Terjadi kesalahan saat mengambil agen' })
      } finally {
        this.disable = false
      }
    },
    isAnyFormDataEmpty() {
      const requiredFields = [
        'phone_number',
        'name',
        'brand',
        'gender',
        'language_style',
        'greeting',
        'job_description',
        'address_id',
        'payment_method',
        'product_ids',
      ]
      if (this.formData.payment_method.includes('BANK_TRANSFER')) {
        requiredFields.push('bank_account_ids')
      }

      const hasShipment = this.formData.shipments && this.formData.shipments.length > 0

      return requiredFields.some(field => {
        const value = this.formData[field]
        if (field === 'product_ids') {
          return !Array.isArray(value) || value.length === 0
        }
        return value === undefined || value === null || String(value).trim() === ''
      }) || !hasShipment
    },
  },
}
</script>
